import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import CommonConstants from "../../../utils/CommonConstants";

export default class InvitedPeopleListController {
  static $inject = ['$scope', 'CartService', '$mdDialog', 'Message', 'Session', '$rootScope', 'cartonomyConfig', '$state', 'HeapService', 'OrderSetupService', 'ConfigurationService','GroupOrder', '$translate'];

  constructor(scope, cartService, dialogService, messageService, sessionService, rootScope, cartonomyConfig, stateService, HeapService, orderSetupService, configurationService,groupOrderService, $translate) {

        this._scope = scope;
        this._dialogService = dialogService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._rootScope = rootScope;
        this._sessionService = sessionService;
        this._cartonomyConfig = cartonomyConfig;
        this._stateService = stateService;
        this._heapService = HeapService;
        this._orderSetupService = orderSetupService;
        this._configurationService = configurationService;
        this._groupOrderService = groupOrderService;
        this.$translate = $translate;
        
        scope.searchString = '';
        scope.contacts = [];

        scope.clearSearch = () => this._clearSearch();
        scope.inviteMorePeople = () => this._inviteMorePeople();
        scope.filterContacts = () => this._filterContacts();
        scope.isCurrentUser = (contact) => this._isCurrentUser(contact);
        scope.resendInvitation = (contact) => this._resendInvitation(contact);
        scope.removeFromCart = (contact) => this._removeFromCart(contact);

        scope.makeContactGroupOwner = (contact) => this._makeContactGroupOwner(contact);
        scope.leaveOrder = () => this._leaveOrder();
        scope.cancelOrder = () => this._cancelOrder();
        scope.isLocked = () => this.isLocked();
        scope.canRemoveUser = (contact) => this.canRemoveUser(contact);
        scope.invitationLink = this._cartService.getInviteSingleLink();
        scope.invitationType = this._cartService.getInvitationType();
        scope.invitationCode = this._cartService.getInviteCode();
        scope.copyClipboard = () => this._copyClipboard();
        scope.isStealthUserMode = this._sessionService.getStealthUserMode();
        scope.marketingMode = this._rootScope.retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing;

  }
  async $onInit() {
    await this._initInvitationCode();
    await this._fetchParticipants();

    this._rootScope.storeWindowTitle = 'client.members';
    this._rootScope.$on(Constants.RootEvents.CART_CHANGED, () => this._fetchParticipants());
    this._rootScope.$on(Constants.RootEvents.DELETE_CONTACT_CONFIRM_FROM_ADDMORE_PEOPLE, (scope, contact) => this._onDialogDeleteContact(scope, contact));
    scopeUtils.apply(this._scope);
  }

  async _fetchParticipants() {
    if (!(await this._sessionService.loggedIn()))
      return;

    this.currentUserEmail = await this._sessionService.getUserEmail();

    if(this._scope.isStealthUserMode){
        this._cartService.getCart().then(cart => {
            this.cart = cart;
            this._cartService.isOwner(cart).then(isOwner => {
                this._scope.isOwner = isOwner;
            });
            let participants = cart.participants;
            this._onReceivedParticipants(participants);
        });
    }else{
        this._cartService.getCart().then(cart => {
            this.cart = cart;
            this._cartService.isOwner(cart).then(isOwner => {
                this._scope.isOwner = isOwner;
            });
        });

        try {
            let participants = await this._cartService.getParticipants();
            this._onReceivedParticipants(participants);
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
        } finally {
            scopeUtils.apply(this._scope);
        }
    }
  }

  isLocked() {
    let isLocked = this.cart && (this.cart.cartStatus === "CHECKING_OUT" || this.cart.cartStatus === "OWNER_CHECKING_OUT");

    return isLocked;
  }

  canRemoveUser(contact) {
    return !contact.invitationResending && !contact.isOwner && contact.paymentStatus === 0;
  }

  _isCurrentUser(contact) {
    return contact.email === this.currentUserEmail;
  }

  async _removeFromCart(contact) {
    if (!this._scope.isOwner || contact.isOwner)
      return;

    const confirmed = await this._messageService.showQuestionPopup(
      this.$translate.instant('client.cart.remove_items', {contactName: contact.name})
    );

    if (!confirmed) {
      return;
    }

    try {
      const response = await this._cartService.removeParticipant(contact.email);

      this._heapService.track('Remove-Participant', { email: contact.email });
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  async _resendInvitation(contact) {
    if (contact.isOwner)
      return;
        
    try {
      contact.invitationResending = true;
      let response = await this._cartService.sendInvites([contact.email]);

      if (response.data[0]) {
        if (response.data[0].status === "INVITESENT" || response.data[0].status === "INVITED") {
          await this._messageService.showMessagePopup(this.$translate.instant('client.user.email_sent', {contactEmail: contact.email }));
        } else if (response.data[0].status === "JOINED") {
          await this._messageService.showMessagePopup(this.$translate.instant('client.user.email_resent', {contactEmail: contact.email }));
        }
      }
      scopeUtils.apply(this._scope, () => {
        contact.invitationResending = false;
      });

      this._heapService.track('Invite-Resend', { email: contact.email });

    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  _participantToContact(participant) {

    // if (participant.status === Constants.CartDetails.Participant.Status.REMOVED) {
    //     return;
    // }

    let status = 'Undefined';

    if (participant.status === Constants.CartDetails.Participant.Status.INVITE_SENT || participant.status === Constants.CartDetails.Participant.Status.INVITED) {
      status = this.$translate.instant('client.invited');
    } else if (participant.status === Constants.CartDetails.Participant.Status.JOINED) {
      status = this.$translate.instant('client.joined');
    } else if (participant.status === Constants.CartDetails.Participant.Status.DECLINED) {
      status = this.$translate.instant('client.declined');
    } else if (participant.status === Constants.CartDetails.Participant.Status.OWNER) {
      status = this.$translate.instant('client.owner');;
    } else if (participant.status === Constants.CartDetails.Participant.Status.LEFT) {
      status = this.$translate.instant('client.order.left');;
    } else if (participant.status === Constants.CartDetails.Participant.Status.REMOVED) {
      status = this.$translate.instant('client.remove');
    }

    const contact = {
      status: status,
      name: participant.name,
      email: participant.email,
      participantId: participant.participantId,
      userId: participant.userId,
      avatar: participant.avatar,
      avatarCropped: participant.avatarCropped,
      isOwner: status == 'Owner',
      paymentStatus: participant.paymentStatus
    };

    if (contact.name === contact.email) {
      contact.name = '';
    }

    contact.firstLetter = (contact.name || contact.email).substring(0, 1);

    return contact;
  }

  _onReceivedParticipants(participants) {
    this._scope.contacts = participants
      .map(participant => this._participantToContact(participant))
      .filter(contact => contact);
  }

  _clearSearch() {
    this._scope.searchString = '';
  }

  _filterContacts() {

    if (!this._scope.searchString) {
      return this._scope.contacts;
    }

    let filter = this._scope.searchString.toLowerCase();

    let contacts = this._scope.contacts.filter(contact =>
      (contact.name && contact.name.toLowerCase().indexOf(filter)) >= 0 ||
      (contact.email && contact.email.toLowerCase().indexOf(filter) >= 0)
    );
    return contacts;
  }

  async _makeContactGroupOwner(contact) {
    let confirmed = await this._messageService.showQuestionPopup(
      this.$translate.instant('client.order.make_owner', { contactName: contact.name }),
      '',
      this.$translate.instant('client.yes'),
      this.$translate.instant('client.no'),
      'md-warn');

    if (!confirmed)
      return null;

    try {
      await this._cartService.transferOwner(contact.participantId);
      await this._messageService.showMessagePopup(this.$translate.instant('client.cart.ownership_transfer', {contactName: contact.name}));
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }

    scopeUtils.apply(this._scope);
  }

  async _initInvitationCode() {
    const cart = await this._cartService.getCart();

    if (cart) {
      if(!this._scope.invitationCode){
        this._scope.invitationCode = await this._cartService.getShareTokenByCartId(cart.id);
        if (this._scope.invitationCode && this._scope.invitationCode > 0) {
          this._cartService.setInviteCode(this._scope.invitationCode);
          this._cartService.setInvitationType(Constants.InvitationTypes.share);
          this._scope.invitationType = Constants.InvitationTypes.share;
        }
      }

      if(!this._scope.invitationLink){
        //Retailer Link
        var _retailer = this._configurationService.getRetailer().retailer;
        if (_retailer.retailerType === 'Shopify') {
          this._scope.invitationLink = 'https://' + _retailer.website + Constants.INVITE_LINK + this._scope.invitationCode;
        } else {
          this._scope.invitationLink = _retailer.website + Constants.INVITE_LINK + this._scope.invitationCode;
        }

        this._cartService.setInviteSingleLink(this._scope.invitationLink);
      }

      scopeUtils.apply(this._scope);      
    }
  }

  async _inviteMorePeople() {

    this._cartService.setInviteMorePeopleMode(true);
    let emails = this._scope.contacts.map(c => c.email);

    await this._orderSetupService.showInviteMorePeople(emails);
  }

  async _cancelOrder() {
    let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.group_cancel_confirm'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

    if (!confirmed)
      return null;

    try {
      await this._cartService.deleteCart();
      await this._cartService.resetCartInvitationType();
      this._rootScope.$broadcast(Constants.Events.ORDER_CANCELLED);

      this._heapService.track('Cart-Cancel', { user: await this._sessionService.getAuthToken() });

      let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CART : Constants.RoutingStates.CATALOG;
      this._stateService.go(stateToGo);
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }

    scopeUtils.apply(this._scope);
  }

  async _leaveOrder() {

    let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.cart.group_leave'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');

    if (!confirmed)
      return null;

    try {
      await this._cartService.leaveCart();

      this._heapService.track('Cart-Leave', { user: await this._sessionService.getAuthToken() });

      if (this._cartonomyConfig.externalStoreMode) {
        this._rootScope.$broadcast(Constants.Events.LEFT_ORDER);
      } else {
        this._stateService.go(Constants.RoutingStates.CATALOG);
      }
    } catch (error) {
      this._messageService.showErrorPopupForResponse(error);
    }
  }

  async _copyClipboard(){
    this._cartService.copyClipboard(this._scope.invitationLink);
  }

    async _onDialogDeleteContact(scope, contact){
        let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.user.remove_contact'), '', this.$translate.instant('client.yes'), this.$translate.instant('client.no'), 'md-warn');
        if(confirmed && contact){
            await this._groupOrderService.deleteContact(contact.contactUserId);
        }

        this._scope.inviteMorePeople();
    }
}



// WEBPACK FOOTER //
// ./src/modules/cart/controllers/InvitedPeopleListController.js